import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import QuestionTwoScreen from "./components/QuestionTwoScreen.js";
import QuestionThreeScreen from "./components/QuestionThreeScreen.js";
import QuestionFourScreen from "./components/QuestionFourScreen.js";
import QuestionFiveScreen from "./components/QuestionFiveScreen.js";
import QuestionSixScreen from "./components/QuestionSixScreen.js";
import QuestionSixBScreen from "./components/QuestionSixBScreen.js";
import QuestionSevenScreen from "./components/QuestionSevenScreen.js";
import QuestionSevenCScreen from "./components/QuestionSevenCScreen.js";
import QuestionSevenBScreen from "./components/QuestionSevenBScreen.js";
import QuestionEightScreen from "./components/QuestionEightScreen.js";
import QuestionEightBScreen from "./components/QuestionEightBScreen.js";
import QuestionEightCScreen from "./components/QuestionEightCScreen.js";
import QuestionEightDScreen from "./components/QuestionEightDScreen.js";
import QuestionNineScreen from "./components/QuestionNineScreen.js";
import QuestionNineBScreen from "./components/QuestionNineBScreen.js";
import QuestionNineCScreen from "./components/QuestionNineCScreen.js";
import QuestionNineDScreen from "./components/QuestionNineDScreen.js";
import QuestionTenScreen from "./components/QuestionTenScreen.js";
import QuestionElevenScreen from "./components/QuestionElevenScreen.js";
import QuestionElevenBScreen from "./components/QuestionElevenBScreen.js";
import QuestionElevenCScreen from "./components/QuestionElevenCScreen.js";
import QuestionElevenDScreen from "./components/QuestionElevenDScreen.js";
import QuestionTwelveScreen from "./components/QuestionTwelveScreen.js";
import QuestionTwelveBScreen from "./components/QuestionTwelveBScreen.js";
import QuestionThirteenScreen from "./components/QuestionThirteenScreen.js";
import QuestionThirteenBScreen from "./components/QuestionThirteenBScreen.js";
import QuestionThirteenCScreen from "./components/QuestionThirteenCScreen.js";
import QuestionThirteenDScreen from "./components/QuestionThirteenDScreen.js";
import QuestionThirteenEScreen from "./components/QuestionThirteenEScreen.js";
import QuestionThirteenFScreen from "./components/QuestionThirteenFScreen.js";
import QuestionThirteenGScreen from "./components/QuestionThirteenGScreen.js";
import QuestionThirteenHScreen from "./components/QuestionThirteenHScreen.js";
import QuestionThirteenIScreen from "./components/QuestionThirteenIScreen.js";
import QuestionThirteenJScreen from "./components/QuestionThirteenJScreen.js";
import QuestionThirteenKScreen from "./components/QuestionThirteenKScreen.js";
import QuestionThirteenLScreen from "./components/QuestionThirteenLScreen.js";
import QuestionFourteenScreen from "./components/QuestionFourteenScreen.js";
import QuestionFourteenBScreen from "./components/QuestionFourteenBScreen.js";
import QuestionFourteenCScreen from "./components/QuestionFourteenCScreen.js";
import QuestionFourteenDScreen from "./components/QuestionFourteenDScreen.js";
import QuestionFifteenScreen from "./components/QuestionFifteenScreen.js";
import QuestionSixteenScreen from "./components/QuestionSixteenScreen.js";
import QuestionSixteenBScreen from "./components/QuestionSixteenBScreen.js";
import QuestionSixteenCScreen from "./components/QuestionSixteenCScreen.js";
import QuestionSeventeenScreen from "./components/QuestionSeventeenScreen.js";
import QuestionSeventeenBScreen from "./components/QuestionSeventeenBScreen.js";
import QuestionSeventeenCScreen from "./components/QuestionSeventeenCScreen.js";
import QuestionSeventeenDScreen from "./components/QuestionSeventeenDScreen.js";
import QuestionEighteenScreen from "./components/QuestionEighteenScreen.js";
import QuestionEighteenBScreen from "./components/QuestionEighteenBScreen.js";
import QuestionEighteenCScreen from "./components/QuestionEighteenCScreen.js";
import QuestionEighteenDScreen from "./components/QuestionEighteenDScreen.js";
import QuestionNineteenScreen from "./components/QuestionNineteenScreen.js";
import QuestionTwentyScreen from "./components/QuestionTwentyScreen.js";
import StartScreen from "./components/StartScreen.js";
import ThanksScreen from "./components/ThanksScreen.js";
import "./App.css";

const UserDataSearchSync = ({ userData }) => {
  const location = useLocation();
  useEffect(() => {
    if (!userData) return;
    const params = new URLSearchParams(location.search);
    if (params.get('origin')) return; // already present
    ['s3', 'origin', 'UUID', 'examType', 'attemptNumber'].forEach((key) => {
      if (userData[key]) params.set(key, userData[key]);
    });
    const newUrl = `${location.pathname}?${params.toString()}${location.hash || ''}`;
    window.history.replaceState({}, '', newUrl);
  }, [location, userData]);
  return null;
};

const App = ({ userData }) => {
  const swRegistrationRef = useRef(null);
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register("/sw.js", { scope: '/' })
        .then((registration) => {
          swRegistrationRef.current = registration;
          console.log("Service Worker: registered");
        })
        .catch((error) => {
          console.log("Service Worker: registration failed", error);
        });
    }
  }, []);

  return (
    <div>
      <Router>
        <UserDataSearchSync userData={userData} />
        <Routes>
          <Route path="/*" element={<StartScreen userData={userData} />}></Route>
          <Route path="/Q2Screen" element={<QuestionTwoScreen userData={userData} />}></Route>
          <Route path="/Q3Screen" element={<QuestionThreeScreen userData={userData} />}></Route>
          <Route path="/Q4Screen" element={<QuestionFourScreen userData={userData} />}></Route>
          <Route path="/Q5Screen" element={<QuestionFiveScreen userData={userData} />}></Route>
          <Route path="/Q6Screen" element={<QuestionSixScreen userData={userData} />}></Route>
          <Route path="/Q6BScreen" element={<QuestionSixBScreen userData={userData} />}></Route>
          <Route path="/Q7Screen" element={<QuestionSevenScreen userData={userData} />}></Route>
          <Route path="/Q7BScreen" element={<QuestionSevenBScreen userData={userData} />}></Route>
          <Route path="/Q7CScreen" element={<QuestionSevenCScreen userData={userData} />}></Route>
          <Route path="/Q8Screen" element={<QuestionEightScreen userData={userData} />}></Route>
          <Route path="/Q8BScreen" element={<QuestionEightBScreen userData={userData} />}></Route>
          <Route path="/Q8CScreen" element={<QuestionEightCScreen userData={userData} />}></Route>
          <Route path="/Q8DScreen" element={<QuestionEightDScreen userData={userData} />}></Route>
          <Route path="/Q9Screen" element={<QuestionNineScreen userData={userData} />}></Route>
          <Route path="/Q9BScreen" element={<QuestionNineBScreen userData={userData} />}></Route>
          <Route path="/Q9CScreen" element={<QuestionNineCScreen userData={userData} />}></Route>
          <Route path="/Q9DScreen" element={<QuestionNineDScreen userData={userData} />}></Route>
          <Route path="/Q10Screen" element={<QuestionTenScreen userData={userData} />}></Route>
          <Route path="/Q11Screen" element={<QuestionElevenScreen userData={userData} />}></Route>
          <Route path="/Q11BScreen" element={<QuestionElevenBScreen userData={userData} />}></Route>
          <Route path="/Q11CScreen" element={<QuestionElevenCScreen userData={userData} />}></Route>
          <Route path="/Q11DScreen" element={<QuestionElevenDScreen userData={userData} />}></Route>
          <Route path="/Q12Screen" element={<QuestionTwelveScreen userData={userData} />}></Route>
          <Route path="/Q12BScreen" element={<QuestionTwelveBScreen userData={userData} />}></Route>
          <Route path="/Q13Screen" element={<QuestionThirteenScreen userData={userData} />}></Route>
          <Route path="/Q13BScreen" element={<QuestionThirteenBScreen userData={userData} />}></Route>
          <Route path="/Q13CScreen" element={<QuestionThirteenCScreen userData={userData} />}></Route>
          <Route path="/Q13DScreen" element={<QuestionThirteenDScreen userData={userData} />}></Route>
          <Route path="/Q13EScreen" element={<QuestionThirteenEScreen userData={userData} />}></Route>
          <Route path="/Q13FScreen" element={<QuestionThirteenFScreen userData={userData} />}></Route>
          <Route path="/Q13GScreen" element={<QuestionThirteenGScreen userData={userData} />}></Route>
          <Route path="/Q13HScreen" element={<QuestionThirteenHScreen userData={userData} />}></Route>
          <Route path="/Q13IScreen" element={<QuestionThirteenIScreen userData={userData} />}></Route>
          <Route path="/Q13JScreen" element={<QuestionThirteenJScreen userData={userData} />}></Route>
          <Route path="/Q13KScreen" element={<QuestionThirteenKScreen userData={userData} />}></Route>
          <Route path="/Q13LScreen" element={<QuestionThirteenLScreen userData={userData} />}></Route>
          <Route path="/Q14Screen" element={<QuestionFourteenScreen userData={userData} />}></Route>
          <Route path="/Q14BScreen" element={<QuestionFourteenBScreen userData={userData} />}></Route>
          <Route path="/Q14CScreen" element={<QuestionFourteenCScreen userData={userData} />}></Route>
          <Route path="/Q14DScreen" element={<QuestionFourteenDScreen userData={userData} />}></Route>
          <Route path="/Q15Screen" element={<QuestionFifteenScreen userData={userData} />}></Route>
          <Route path="/Q16Screen" element={<QuestionSixteenScreen userData={userData} />}></Route>
          <Route path="/Q16BScreen" element={<QuestionSixteenBScreen userData={userData} />}></Route>
          <Route path="/Q16CScreen" element={<QuestionSixteenCScreen userData={userData} />}></Route>
          <Route path="/Q17Screen" element={<QuestionSeventeenScreen userData={userData} />}></Route>
          <Route path="/Q17BScreen" element={<QuestionSeventeenBScreen userData={userData} />}></Route>
          <Route path="/Q17CScreen" element={<QuestionSeventeenCScreen userData={userData} />}></Route>
          <Route path="/Q17DScreen" element={<QuestionSeventeenDScreen userData={userData} />}></Route>
          <Route path="/Q18Screen" element={<QuestionEighteenScreen userData={userData} />}></Route>
          <Route path="/Q18BScreen" element={<QuestionEighteenBScreen userData={userData} />}></Route>
          <Route path="/Q18CScreen" element={<QuestionEighteenCScreen userData={userData} />}></Route>
          <Route path="/Q18DScreen" element={<QuestionEighteenDScreen userData={userData} />}></Route>
          <Route path="/Q19Screen" element={<QuestionNineteenScreen userData={userData} />}></Route>
          <Route path="/Q20Screen" element={<QuestionTwentyScreen userData={userData} />}></Route>
          <Route path="/ThanksScreen" element={<ThanksScreen userData={userData} />}></Route>
        </Routes>
      </Router>
    </div>
  );
};

export default App;
